module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('h2', {
    staticClass: "sec_front"
  }, [_vm._v("NOTABLE BATTLESHIPS AND BATTLECRUISERS")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_vm._v("IJN "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mikasa")]), _vm._v(" (1902)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("Japanese pre-dreadnought battleship; flagship at the Battle of Tsushima. The world’s oldest existing battleship.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_vm._v("HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dreadnought (1906)")])]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("British battleship heralding a revolution in battleship design by being the first of its era to have a uniform main battery and steam turbines.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_vm._v("HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Invincible")]), _vm._v(" (1907)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("The world’s first battlecruiser; armed as a battleship and fast as a cruiser. Able to chase down most ships, while allowing it to run from more powerful designs.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_vm._v("SMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Goeben")]), _vm._v(" (1911)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("German battlecruiser transferred to the Ottoman Navy in World War I. In Turkish service until 1954; the world’s longest actively serving capital warship.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_vm._v("IJN "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arkansas")]), _vm._v(" (1912)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("American battleship; the world’s first battleship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("directly")]), _vm._v(" sunk by an atomic bomb during tests labelled Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Crossroads")]), _vm._v(" at Bikini Atoll in 1946.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_vm._v("HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Queen Elizabeth (1913)")])]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("The world’s first fast battleship combining the advantages of a heavily armoured battleship and a fast battlecruiser in one design.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_vm._v("USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arizona")]), _vm._v(" (1915)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("American super-dreadnought sunk by Japanese bombers in the attack on Pearl Harbor on December 7, 1941.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_vm._v("IJN "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ise")]), _vm._v(" (1916)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("Japanese battleship; the first to be converted into a hybrid battleship/aircraft carrier (along with its sister ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hyūga")]), _vm._v(").")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_vm._v("HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hood")]), _vm._v(" (1918)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("The Royal Navy’s last battlecruiser and the world’s largest warship for two decades. It was sunk by the German battleship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bismarck")]), _vm._v(" in 1941.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Panzerschiff Deutschland")]), _vm._v(" (1931)")])]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("Often labelled a “pocket-battleship”, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" was the first German capital ship launched after World War I meeting the terms of the Versailles Treaty. Its design motto was to be “more powerful than fast ships, and faster than more powerful ships”.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bismarck")]), _vm._v(" (1940)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("The world’s largest warship when it sank HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hood")]), _vm._v(" in 1941. Three days later, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bismarck")]), _vm._v(" finally succumbed to superior British naval forces after the largest hunt for a single warship in history.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_vm._v("USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Missouri")]), _vm._v(" (1944)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("America’s last completed battleship and the site of Japan’s official surrender ending World War II. Recommissioned for the Korean War and Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Desert Storm,")]), _vm._v(" the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mighty Mo")]), _vm._v(" was the world’s last active battleship when finally decommissioned in 1992.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_vm._v("IJN "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yamato")]), _vm._v(" (1940)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("The heaviest and most powerfully armed battleship ever completed (along with its sister ship, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Musashi).")]), _vm._v(" Sunk by US aircraft in 1945.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Roma")]), _vm._v(" (1940)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("Italy’s last commissioned battleship; sunk by a German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fritz X")]), _vm._v(" bomb in 1943, one of the world’s first precision guided weapons.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1_s w30"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jean Bart")]), _vm._v(" (1940)")]), _vm._v(" "), _c('td', {
    staticClass: "td2_s w70"
  }, [_vm._v("Launched in 1940, the French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jean Bart")]), _vm._v(" was the world’s last commissioned battleship in 1949.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1233456","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Notable_battleships.vue
// module id = 75
// module chunks = 0